// extracted by mini-css-extract-plugin
export default {"mCard":"fC-z","image":"gC-z","imageNoBackground":"hC-z","imageHasCategory":"iC-z","fullWidth":"jC-z"};